
import { EtiquetaResumen } from "components";
import { Grid, Typography } from "@material-ui/core";
import NumberFormat from "react-number-format";

const Detalles = ({sistemaSeleccionado})=>{
return(
  <Grid item container xs={12} spacing={1}>
  <Grid item xs={4}>
    <EtiquetaResumen
      expanded={false}
      showIconDetail={false}
      titulo={
        <Grid container justifyContent="space-between">
          <Grid item xs>
            <Typography variant="h6">
              Número de tareas por proyecto vigente:
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="h5">
              {sistemaSeleccionado?.tareasAct}
            </Typography>
          </Grid>
        </Grid>
      }
      detalle=""
    />
  </Grid>
  <Grid item xs={4}>
    <EtiquetaResumen
      expanded={false}
      showIconDetail={false}
      titulo={
        <Grid container justifyContent="space-between">
          <Grid item xs>
            <Typography variant="h6">
              Cumplimientos de horas:
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h5">
              <NumberFormat
                value={sistemaSeleccionado?.pCumplimiento}
                decimalScale={2}
                suffix="%"
                displayType="text"
              />
            </Typography>
          </Grid>
        </Grid>
      }
      detalle=""
    />
  </Grid>
  <Grid item xs={4}>
    <EtiquetaResumen
      expanded={false}
      showIconDetail={false}
      titulo={
        <Grid container justifyContent="space-between">
          <Grid item xs>
            <Typography variant="h6">
              Calificación de encuesta:
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="h5">
              <NumberFormat
                value={
                  sistemaSeleccionado?.porcentajeEncuesta
                }
                thousandSeparator=","
                decimalScale={2}
                suffix="%"
                displayType="text"
              />
            </Typography>
          </Grid>
        </Grid>
      }
      detalle=""
    />
  </Grid>
  <Grid item xs={4}>
    <EtiquetaResumen
      expanded={false}
      showIconDetail={false}
      titulo={
        <Grid container justifyContent="space-between">
          <Grid item xs>
            <Typography variant="h6">
              Horas de testeo:
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="h5">
              <NumberFormat
                value={sistemaSeleccionado?.hrsTesteo}
                thousandSeparator=","
                decimalScale={0}
                displayType="text"
              />
            </Typography>
          </Grid>
        </Grid>
      }
      detalle=""
    />
  </Grid>
  <Grid item xs={4}>
    <EtiquetaResumen
      expanded={false}
      showIconDetail={false}
      titulo={
        <Grid container justifyContent="space-between">
          <Grid item xs>
            <Typography variant="h6">
              Modificaciones de alcance:
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="h5">
              {sistemaSeleccionado?.tareasMA}
            </Typography>
          </Grid>
        </Grid>
      }
      detalle=""
    />
  </Grid>
  <Grid item xs={4}>
    <EtiquetaResumen
      titulo={
        <Grid container justifyContent="space-between">
          <Grid item xs>
            <Typography variant="h6">
              Bono:
            </Typography>
          </Grid>
        </Grid>
      }
      detalle={
        <Typography style={{ fontSize: "0.8rem" }}>
          { sistemaSeleccionado?.bono 
            ? sistemaSeleccionado.bono.map((bn) => ( <div key={bn.idbono}>{`${bn.nBono} - ${bn.numSolicitudes}`}</div>))
            : 'N/A'
          }
        </Typography>
      }
    />
  </Grid>
  <Grid item xs={4}>
    <EtiquetaResumen
      titulo={
        <Grid container justifyContent="space-between">
          <Grid item xs>
            <Typography variant="h6">
              Integrantes del proyecto:
            </Typography>
          </Grid>
        </Grid>
      }
      detalle={
        <Grid item xs>
          <Typography style={{ fontSize: "0.8rem" }}>
            {sistemaSeleccionado?.integrantes 
              ? sistemaSeleccionado.integrantes.map((bn) => ( <div key={bn.idusuario} >{`${bn.nombre} - ${bn.nrol}`}</div>))
              : ('N/A')}
          </Typography>
        </Grid>
      }
    />
  </Grid>
  <Grid item xs={4}>
    <EtiquetaResumen
      titulo={
        <Grid container justifyContent="space-between">
          <Grid item xs>
            <Typography variant="h6">
              Interaccciones con el cliente:
            </Typography>
          </Grid>
        </Grid>
      }
      detalle={
        <Grid item xs>
          <Typography style={{ fontSize: "0.8rem" }}>
            {sistemaSeleccionado?.interacciones && sistemaSeleccionado?.interacciones?.length > 0
              ? sistemaSeleccionado.interacciones.map(
                  (bn) => (
                    <div
                      key={bn.nseguimiento}
                    >{`${bn.nseguimiento}: ${bn.cantidad}`}</div>
                  )
                )
              : "N/A"}
          </Typography>
        </Grid>
      }
    />
  </Grid>
</Grid>
);
};
export default Detalles;
